<div class="background">
  <div class="video-container">
    <video #videoPlayer loop autoplay muted="true" playsinline class="background-video">
      <source src="assets/videos/background-midia.mp4" type="video/mp4" />
    </video>
  </div>
  <div class="container" *ngIf="!showText">
    <img src="assets/images/ecos.png" alt="" class="logo-ecos">
    <button class="btn-open" (click)="showText = true">Clique para ecoar</button>
    <!-- <h1 class="title">Midianitas</h1> -->
    <!-- <h2 class="subtitle">Ecos de esperança</h2> -->
    <!-- <p class="text">
      Aos queridos Midianitas,<br/><br/> Vocês não são apenas uma equipe de mídia; vocês
      são agentes de transformação, pontes entre o Evangelho e aqueles que mais
      precisam ouvi-lo. <br/><br/>Cada vídeo que vocês produzem, cada imagem que capturam,
      cada transmissão que realizam é uma semente lançada no coração de alguém,
      um farol de luz que brilha nas sombras da desesperança.<br/><br/> Nos bastidores,
      onde poucos os veem, vocês trabalham com dedicação, criatividade e zelo,
      permitindo que a Palavra de Deus alcance lugares que talvez nunca
      visitaríamos fisicamente. Cada detalhe do seu esforço – a escolha de uma
      música, a edição precisa, a transmissão impecável – conta uma história de
      amor e obediência ao chamado de Cristo.<br/><br/> Vocês
      ampliam a voz do Evangelho, fazendo com que ele alcance aqueles que estão
      cansados, perdidos e sedentos por uma palavra de esperança. Vocês são como os arautos
      modernos, transmitindo a mensagem de salvação e graça de forma inovadora e
      poderosa. <br/><br/>O que realizam hoje, mesmo que pareça pequeno, ecoará na
      eternidade, glorificando o Reino e abençoando incontáveis vidas. <br/><br/>Com
      gratidão e admiração, agradecemos por cada minuto investido, por cada
      talento oferecido, e por cada esforço feito com excelência. Vocês fazem
      parte de algo grandioso, e Deus tem usado suas vidas de forma
      extraordinária. Continuem firmes, pois o que vocês fazem é precioso aos
      olhos do Senhor. <br/><br/>Vocês são verdadeiros ecos de esperança para este mundo.
      <br/><br/>Obrigado, Midianitas!
    </p> -->
  </div>
  <div class="container-text" *ngIf="showText">
    <img src="assets/images/ecos.png" alt="" class="logo-ecos">
    <p class="text">
      Aos queridos Midianitas,<br/><br/> Vocês não são apenas uma equipe de mídia; vocês
      são agentes de transformação, pontes entre o Evangelho e aqueles que mais
      precisam ouvi-lo. <br/><br/>Cada vídeo que vocês produzem, cada imagem que capturam,
      cada transmissão que realizam é uma semente lançada no coração de alguém,
      um farol de luz que brilha nas sombras da desesperança.<br/><br/> Nos bastidores,
      onde poucos os veem, vocês trabalham com dedicação, criatividade e zelo,
      permitindo que a Palavra de Deus alcance lugares que talvez nunca
      visitaríamos fisicamente. Cada detalhe do seu esforço – a escolha de uma
      música, a edição precisa, a transmissão impecável – conta uma história de
      amor e obediência ao chamado de Cristo.<br/><br/> Vocês
      ampliam a voz do Evangelho, fazendo com que ele alcance aqueles que estão
      cansados, perdidos e sedentos por uma palavra de esperança. Vocês são como os arautos
      modernos, transmitindo a mensagem de salvação e graça de forma inovadora e
      poderosa. <br/><br/>O que realizam hoje, mesmo que pareça pequeno, ecoará na
      eternidade, glorificando o Reino e abençoando incontáveis vidas. <br/><br/>Com
      gratidão e admiração, agradecemos por cada minuto investido, por cada
      talento oferecido, e por cada esforço feito com excelência. Vocês fazem
      parte de algo grandioso, e Deus tem usado suas vidas de forma
      extraordinária. Continuem firmes, pois o que vocês fazem é precioso aos
      olhos do Senhor. <br/><br/>Vocês são verdadeiros ecos de esperança para este mundo.
      <br/><br/>Obrigado, Midianitas!
    </p>
  </div>
</div>
